<template lang="html">
  <section class="fechamento-multa-sla">
      <table class="table table-bordered table-condensed table-hover" border="1">
        <tbody>
          <tr>
            <td class="numero-item bg-color-extremidades alinhar-conteudo fonte-tabela" rowspan="15">  </td>
            <td class="descricao-sla bg-color-extremidades fonte-tabela" colspan="15">Resumo mensal</td>
          </tr>

          <tr>
            <td class="detalhe-descricao fonte-tabela" colspan="15"><strong>Fechamento mensal multa / sla</strong></td>
          </tr>

          <tr>
            <td class="titulo-lateral-linha fonte-tabela" colspan="1">Meses</td>
            <td class="meses alinhar-conteudo fonte-tabela" v-for="item in glosas"><strong>{{ item.mes.sigla }}</strong></td>
          </tr>

          <tr>
            <td class="titulo-lateral-linha fonte-tabela" colspan="1">Valor da multa </td>
            <td class="alinhar-conteudo fonte-tabela" v-for="multa in valorMultas">
              <money :value="multa.moeda" v-bind="money" readonly class="formatacao-input-exibe-puro-texto"></money>
            </td>
          </tr>

          <tr v-if = "this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4">
            <td class="titulo-lateral-linha fonte-tabela" colspan="1">Valor da glosa</td>
            <td class="alinhar-conteudo fonte-tabela" v-for="item in glosas">
              <money :value="item.moeda" v-bind="money" readonly class="formatacao-input-exibe-puro-texto"></money>
            </td>
          </tr>

          <tr>
            <td class="titulo-lateral-linha fonte-tabela" colspan="1">Total</td>
            <td class="alinhar-conteudo fonte-tabela" v-for="item in totalMultaGlosa">
              <money :value="item.moeda" v-bind="money" readonly class="formatacao-input-exibe-puro-texto"></money>
            </td>
          </tr>

          <tr>
            <td class="titulo-lateral-linha fonte-tabela" colspan="1">Fechamento</td>
            <td class="alinhar-conteudo fonte-tabela" v-for="fechamentoMes in fechamentoMultaGlosa">
              <div v-if="!fechamentoMes.envio_confirmado">
                <a
                  v-on:click="exibirModalFechamentoMultaSla(fechamentoMes, 'NOVO')"
                  href="javascript:void(0)"
                  data-toggle="listarGlosas"
                >
                {{ statusFechamento.enviar }}
                </a>
              </div>

              <div v-else>
                <a
                  v-on:click="exibirModalFechamentoMultaSla(fechamentoMes, 'EXIBIR')"
                  href="javascript:void(0)"
                  data-toggle="listarGlosas"
                >
                {{ statusFechamento.enviado }}
                </a>
              </div>
            </td>
          </tr>

        </tbody>
    </table>
  </section>
</template>

<script>
import {Money} from 'v-money'
import impressaoGlosa from '../../glosa/print/GlosaImpressao.vue'

export default {
  props: ['contrato', 'ano', 'uf', 'multas', 'fornecedor'],
  data: function () {
    return {
      anoSelecionado: '',
      contratoSelecionado: [],
      ufSelecionada: '',
      mesSelecionado: '',
      valorMultas: [],
      glosas: [],
      totalMultaGlosa: [],
      fechamentoMultaGlosa: [],
      confirmacaoMultaGlosaAtual: null,
      controlerLoading: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      env: process.env,
      statusFechamento: {enviar: 'Enviar', enviado: 'Enviado'},
      dados: []
    }
  },
  mounted: function () {
    this.definePros()
    this.getTotalGlosasAplicadasMensal()
    this.getConfirmacaoAplicacaoFechamentoMultaGlosa(this.ufSelecionada, this.anoSelecionado, this.contratoSelecionado)
  },
  components: {
    Money,
    'exibir-glosas-impressao': impressaoGlosa
  },
  watch: {
    ano: function () {
      this.definePros()
      this.getTotalGlosasAplicadasMensal()
      this.getConfirmacaoAplicacaoFechamentoMultaGlosa(this.ufSelecionada, this.anoSelecionado, this.contratoSelecionado)
    }
  },
  methods: {
    definePros: function () {
      this.anoSelecionado = this.ano
      this.contratoSelecionado = this.contrato
      this.ufSelecionada = this.uf
      this.valorMultas = this.multas
    },
    exibirModalFechamentoMultaSla: function (fechamentoMes, modo) {
      const siglaMes = fechamentoMes.mes_sigla

      this.confirmacaoMultaGlosaAtual = {
        uf: this.contratoSelecionado.uf,
        uf_id: this.ufSelecionada,
        tipo_imovel_servico: this.contratoSelecionado.tipo_imovel_servico,
        tipo_imovel_servico_id: this.contratoSelecionado.tipo_imovel_servico_id,
        mes_id: fechamentoMes.mes_id,
        mes_sigla: siglaMes,
        ano: this.anoSelecionado,
        glosa: this.glosas[siglaMes].valor,
        multa: this.valorMultas[siglaMes].valor,
        total: this.totalMultaGlosa[siglaMes].valor,
        nome_arquivo: fechamentoMes.nome_arquivo,
        observacao: fechamentoMes.observacao,
        modo: modo
      }
      this.$store.commit('setModalConfirmarMultaGlosa', {conteudo: null, show: true})
      this.$store.commit('setConfirmarMultaGlosa', {dados: this.confirmacaoMultaGlosaAtual})
    },
    getTotalGlosasAplicadasMensal: function () {
      let vm = this

      let formData = new FormData()
      formData.append('ano', this.anoSelecionado)
      formData.append('contrato_id', this.contratoSelecionado.contrato_id)

      this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/getGlosaFiltroAnoContrato`, formData, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.glosas = response.data
        vm.getCalculoFechamentoMultaGlosa()
        vm.controlerLoading = true
      })
      .catch(error => {
        this.controlerLoading = true
        console.log(error)
      })
    },
    getCalculoFechamentoMultaGlosa: function () {
      let vm = this
      this.controlerLoading = false
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getCalculoFechamentoMultaGlosa`, {
        glosas: this.glosas,
        multas: this.valorMultas
      }, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.totalMultaGlosa = response.data
        vm.controlerLoading = true
      })
      .catch(error => {
        this.controlerLoading = true
        console.log(error)
      })
    },
    getConfirmacaoAplicacaoFechamentoMultaGlosa: function (uf, ano, contrato) {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/getConfirmacaoFechamentoMultaGlosa`, {
        params: {
          uf,
          ano,
          tipo_imovel_servico_id: contrato.tipo_imovel_servico_id
        },
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(function (response) {
        vm.fechamentoMultaGlosa = response.data
        let obj = response.data
        let meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
        var res = Object.entries(obj)
        let arrayFechamento = []
        let arrayFechamentoBlank = []
        meses.forEach(function (item, index) {
          arrayFechamento[index] = res[index][1]['envio_confirmado']
          arrayFechamentoBlank[item] = res[index][1]['envio_confirmado']
        })
        vm.$store.state.fechamentoMultaGlosa = arrayFechamento
      })
      .catch(error => {
        console.warn('erro', error)
      })
    }
  }
}
</script>
<style scoped src="../css/controleApuracaoSla.css" />



// WEBPACK FOOTER //
// TableFechamentoMultaGlosa.vue?41859089